/**
 * 【KYMW1404】掲載候補商品データ取得用VO
 *
 * @export NominationGoodsDataModel
 * @class NominationGoodsDataModel
 */
export class NominationGoodsDataModel {
  /**
   * 画面ID
   */
  public formID = String('KYMW1404');

  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 生協コード
   */
  public coopCode = String('');

  /**
   *  ページ番号
   */
  public pageNum = String('');

  /**
   *  売り場コード
   */
  public sellAreaCode = String('');

  /**
   * 部門コード
   */
  public classCode = String('');

  // 注文コード割当条件追加対応
  public orderNumQuota = String('');

  /**
   * 部門コード配列
   */
  public classCodeArray: Array<any> = new Array<any>();

  /**
   * Ｗ掲載予定のみフラグ
   */
  public wPubilshFlg = Number(0);

  /**
   * 未掲載候補のみフラグ
   */
  public notPublishFlg = Number(0);

  /**
   * 商品案内用商品名
   */
  public guideGoodsName = String('');

  /**
   * Ｐコード
   */
  public pcode = String('');

  /**
   * 他媒体対象フラグ
   */
  public otherMediumTypeFlg = Number(0);

  /**
   * ソート指定項目
   */
  public sortItem = String('');

  /**
   * 昇順降順
   */
  public sortOrder = String('');

  /**
   * 取得対象ページ
   */
  public page = Number(1);

  /**
   * 注文商品区分
   */
  public orderGoodsFlg = String('01');

  /**
   * アイテムコード
   */
  public itemCode = String('');

  /**
   * 注文コード６桁
   */
  public orderNum6Digits = String('');

  /**
   * 受付開始受注コード
   */
  public receiptSOrderCode = String('');

  /**
   * 適用開始受注コード
   */
  public startOrderCode = String('');

  /*
   * 業態区分デイリー
   */
  public dutiesFormDailyList: Array<any> = new Array<any>();
}
